module.exports = __webpack_public_path__ + "asset-symbols/bnb.png";